import { cn } from "@aircall/ds";
import { ComponentProps, PropsWithChildren } from "react";

export function EvaluationComment({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<"div">>) {
  return (
    <div
      className={cn("flex items-center rounded-lg bg-muted p-2", className)}
      {...props}
    >
      <p className="text-sm font-normal">{children}</p>
    </div>
  );
}
